// extracted by mini-css-extract-plugin
module.exports = {"head":"style_head__2MKqT","title":"style_title__2KK8a","time":"style_time__386pi","content":"style_content__3vs9S","tabs":"style_tabs__1Ixig"};